import BaseRestService from "./BaseRestService";

class CardsLibraryService extends BaseRestService {
  async getAllCards() {
    const url = `/api/v2/cardslibrary/all`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async addCard(id, config, cardData, tabs) {
    const url = `/api/v2/cardslibrary/add`;
    return this.client.post(
      url,
      { data: { id, config, cardData, tabs } },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async editCard(id, config, cardData, tabs) {
    const url = `/api/v2/cardslibrary/edit`;
    return this.client.post(
      url,
      { data: { id, config, cardData, tabs } },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async deleteCard(id) {
    const url = `/api/v2/cardslibrary/delete`;
    return this.client.post(
      url,
      { data: { id } },
      await this.buildJWTAuthAxiosConfig()
    );
  }
}

export const cardsLibraryService = new CardsLibraryService();
